/* NZS Featured Pre-Workout carousel — vanilla, class-toggle (transforms live in CSS).
   Rotates the active flavour via arrows / pills / tub clicks / keyboard / drag and
   sets --tri (triangle colour) from the active item's data-tri. No external deps. */
(function () {
  function init(root) {
    if (!root || root.__fpwBound) return;
    root.__fpwBound = true;

    var stage  = root.querySelector('.fpw__stage');
    var items  = Array.prototype.slice.call(root.querySelectorAll('.fpw__item'));
    var pills  = Array.prototype.slice.call(root.querySelectorAll('.fpw__pill'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.fpw__panel'));
    var n = items.length;
    if (!n || !stage) return;

    var active = 0;
    items.forEach(function (it, i) { if (it.classList.contains('is-active')) active = i; });

    function clsFor(off) {
      if (off === 0)  return 'is-active';
      if (off === -1) return 'is-prev';
      if (off === 1)  return 'is-next';
      if (off === -2) return 'is-farl';
      if (off === 2)  return 'is-farr';
      return 'is-hidden';
    }
    function circOff(i, a) {
      var d = ((i - a) % n + n) % n;      // 0..n-1
      if (d > n / 2) d -= n;              // -n/2 .. n/2
      return d;
    }

    function setActive(a, focusTub, doScroll) {
      active = ((a % n) + n) % n;
      var tri = items[active].getAttribute('data-tri');
      items.forEach(function (it, i) {
        it.className = 'fpw__item ' + clsFor(circOff(i, active));
      });
      pills.forEach(function (p, i) {
        var on = i === active;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      // Keep the active flavour pill centred in the (mobile) scrolling strip.
      // inline:'center' centres horizontally; block:'nearest' avoids a vertical page jump
      // on desktop where the strip doesn't overflow.
      if (doScroll !== false && pills[active] && pills[active].scrollIntoView) {
        pills[active].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
      panels.forEach(function (p, i) {
        var on = i === active;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('aria-hidden'); } else { p.setAttribute('aria-hidden', 'true'); }
      });
      if (tri) { stage.style.setProperty('--tri', tri); root.style.setProperty('--tri', tri); }
      if (focusTub) {
        var btn = items[active].querySelector('.fpw__pbtn');
        if (btn) btn.focus();
      }
    }

    // Arrows
    var prev = root.querySelector('.fpw__arrow--prev');
    var next = root.querySelector('.fpw__arrow--next');
    if (prev) prev.addEventListener('click', function () { setActive(active - 1); });
    if (next) next.addEventListener('click', function () { setActive(active + 1); });

    // Pills + tubs (event delegation)
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-i]');
      if (!t) return;
      if (t.classList.contains('fpw__pill') || t.classList.contains('fpw__pbtn')) {
        var i = parseInt(t.getAttribute('data-i'), 10);
        if (!isNaN(i)) setActive(i);
      }
    });

    // Keyboard on the stage
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); setActive(active + 1); }
    });

    /* NZS-FPW-LIVEDRAG 2026-08-13 (Blake: "make this section grab and swipable"): the old
       handlers only stepped ON RELEASE past a hidden 40px threshold, so nothing moved under
       the pointer and the stage didn't feel grabbable. Now one Pointer-Events path drives
       mouse AND touch: the carousel steps LIVE every STEP px of horizontal drag (rolling
       through flavours as you pull), with pointer capture so the drag survives leaving the
       stage. Axis lock: a mostly-vertical touch is handed straight back to page scroll
       (CSS touch-action:pan-y does the real blocking; see nzs-featured-pw.css). A short
       sub-STEP flick still advances one, so quick swipes keep working. Pill scrollIntoView
       is deferred to drag end — per-step smooth scrolls fight each other mid-drag. */
    var STEP = 90;
    var x0 = null, y0 = 0, pid = null, axis = null, dragging = false, stepped = 0;

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      x0 = e.clientX; y0 = e.clientY; pid = e.pointerId;
      axis = null; dragging = false; stepped = 0;
    });

    stage.addEventListener('pointermove', function (e) {
      if (x0 === null || e.pointerId !== pid) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (axis === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (axis !== 'x') return;
      if (!dragging) {
        dragging = true;
        stage.classList.add('nzs-grabbing');
        try { stage.setPointerCapture(pid); } catch (_) {}
      }
      if (e.cancelable) e.preventDefault();
      var want = Math.trunc(-(e.clientX - x0) / STEP); // drag left => forward
      while (stepped < want) { setActive(active + 1, false, false); stepped++; }
      while (stepped > want) { setActive(active - 1, false, false); stepped--; }
    });

    function endDrag(e) {
      if (x0 === null || e.pointerId !== pid) return;
      var span = e.clientX - x0, wasDrag = dragging, took = stepped;
      x0 = null; pid = null; axis = null; dragging = false; stepped = 0;
      stage.classList.remove('nzs-grabbing');
      if (!wasDrag) return;
      if (took === 0 && Math.abs(span) > 40) setActive(active + (span < 0 ? 1 : -1), false, false);
      if (pills[active] && pills[active].scrollIntoView) {
        pills[active].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
      // A drag must never also activate the tub the pointer was released on. Torn down on a
      // timeout rather than on first click, so a drag that ends off a tub cannot leave a
      // listener behind to eat a later, unrelated click.
      var swallow = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
      stage.addEventListener('click', swallow, true);
      setTimeout(function () { stage.removeEventListener('click', swallow, true); }, 0);
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', function () {
      x0 = null; pid = null; axis = null; dragging = false; stepped = 0;
      stage.classList.remove('nzs-grabbing');
    });
    // native image drag would hijack a mouse grab mid-gesture
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

    setActive(active, false, false); // sync initial --tri + states (no focus, no scroll on load)
  }

  function boot() {
    document.querySelectorAll('[data-fpw]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  // Shopify theme editor re-render
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('[data-fpw]') : null;
    if (r) init(r);
  });
})();
